import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from '@/common/http/base-query';
import { getFullAPIUrl } from '@/env-config';

export enum TagTypes {
  BulkReminder = 'BulkReminder',
  Connector = 'Connector',
  DocumentDelivery = 'DocumentDelivery',
  SignDocument = 'SignDocument',
  Template = 'Template',
  User = 'User',
  UserConnector = 'UserConnector',
  Workflow = 'Workflow',
  WorkflowStep = 'WorkflowStep',
  WorkflowPreviousStepField = 'WorkflowPreviousStepField',
  WorkflowFolder = 'WorkflowFolder',
  WorkflowSubmission = 'WorkflowSubmission',
  WorkflowHistory = 'WorkflowHistory',
  StepSubmission = 'StepSubmission',
  WorkspaceSubmission = 'WorkspaceSubmission',
  WorkspaceSubmissionWorkflow = 'WorkspaceSubmissionWorkflow',
}

export const baseApi = createApi({
  baseQuery: baseQuery({ baseUrl: getFullAPIUrl() }),
  endpoints: () => ({}),
  tagTypes: Object.values(TagTypes),
});

// TODO: this is needed to refetch the data before full migration to RTK Query
// Remove this when no longer needed
export const {
  util: { invalidateTags },
} = baseApi;
